import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray, withFormik } from 'formik';
import { isEmpty, map, uniqueId, some } from 'lodash';
import Yup from 'yup';
import { getFormValue } from '../../../util/helpers';
import { FormLayout, renderFormSection } from '../../common';
import Insurance, { getInsuranceValidation } from './Insurance';

const INSURANCE = 'insurance';

const DEFAULT_INSURANCE = {
  id: undefined,
  isActive: true,
  provider: {
    name: '',
    groupNumber: '',
    notes: '',
    policyNumber: '',
    phoneExtension: '',
    primaryPhoneNumber: '',
  },
  policyHolder: {
    firstName: '',
    lastName: '',
  },
  caseManager: {
    firstName: '',
    lastName: '',
    phoneExtension: '',
    primaryPhoneNumber: '',
  },
};

const getNewInsurance = () => ({
  ...DEFAULT_INSURANCE,
  tempId: uniqueId('temp-'),
});

const hasInsuranceData = ({ provider, policyHolder, caseManager }) =>
  some({
    ...provider,
    ...policyHolder,
    ...caseManager,
  });

function InsuranceForm(props) {
  return (
    <FormLayout {...props}>
      <FieldArray
        name={INSURANCE}
        render={fieldArray =>
          renderFormSection({
            fieldArray,
            props: {
              ...props,
              component: Insurance,
              onAddSection: getNewInsurance,
              title: 'Insurance Provider',
            },
          })
        }
      />
    </FormLayout>
  );
}

InsuranceForm.propTypes = {
  data: PropTypes.array,
};

InsuranceForm.defaultProps = {
  data: [],
};

const toInsuranceValues = insurance => ({
  id: insurance.id,
  tempId: insurance.tempId,
  isActive: getFormValue(insurance, 'isActive'),
  provider: {
    name: getFormValue(insurance, ['provider', 'name'], ''),
    groupNumber: getFormValue(insurance, ['provider', 'groupNumber'], ''),
    notes: getFormValue(insurance, ['provider', 'notes'], ''),
    policyNumber: getFormValue(insurance, ['provider', 'policyNumber'], ''),
    phoneExtension: getFormValue(insurance, ['provider', 'phoneExtension'], ''),
    primaryPhoneNumber: getFormValue(
      insurance,
      ['provider', 'primaryPhoneNumber'],
      '',
    ),
  },
  policyHolder: {
    firstName: getFormValue(insurance, ['policyHolder', 'firstName'], ''),
    lastName: getFormValue(insurance, ['policyHolder', 'lastName'], ''),
    birthday: getFormValue(insurance, ['policyHolder', 'birthday'], ''),
  },
  caseManager: {
    firstName: getFormValue(insurance, ['caseManager', 'firstName'], ''),
    lastName: getFormValue(insurance, ['caseManager', 'lastName'], ''),
    phoneExtension: getFormValue(
      insurance,
      ['caseManager', 'phoneExtension'],
      '',
    ),
    primaryPhoneNumber: getFormValue(
      insurance,
      ['caseManager', 'primaryPhoneNumber'],
      '',
    ),
  },
});

export default withFormik({
  displayName: 'Insurance',
  handleSubmit: (values, { props, setStatus }) =>
    props
      .onSave(values.insurance.filter(hasInsuranceData))
      .then(() => (props.isEditing ? props.onCancel() : props.onContinue()))
      .catch(error => setStatus({ saveError: error })),
  mapPropsToValues: ({ data }) => {
    return {
      insurance: isEmpty(data)
        ? [getNewInsurance()]
        : map(data, toInsuranceValues),
    };
  },
  validationSchema: Yup.object().shape({
    insurance: Yup.array().of(Yup.object().shape(getInsuranceValidation())),
  }),
})(InsuranceForm);



// WEBPACK FOOTER //
// ./src/modules/InsurancePage/components/InsuranceForm.js